<p-tabs
  appTabsUnsavedReveal
  [value]="activeModuleTabIndex()"
  (valueChange)="moduleTabChange.emit(+$event!)"
  class="module-tabs"
  scrollable
>
  <p-tablist>
    @for (moduleTab of moduleTabs(); track moduleTab.moduleId; let i = $index) {
      <p-tab
        [value]="i"
        [appTabStatus]="moduleTabCompletionStatus()[i]"
        [appTabStatusUnsaved]="moduleTabsUnsaved()[i]"
      >
        {{ moduleTab.moduleTranslations | translateDirectus }}
      </p-tab>
    }
  </p-tablist>

  <p-tabpanels class="mt-4">
    @for (moduleTab of moduleTabs(); track moduleTab.moduleId; let moduleIndex = $index) {
      <p-tabpanel [value]="moduleIndex">
        @if (activeModuleTabIndex() === moduleIndex) {
          <p-tabs
            appTabsUnsavedReveal
            [value]="activeModuleScTabIndex()"
            (valueChange)="moduleScTabChange.emit(+$event!)"
            class="subcriteria-tabs"
            scrollable
          >
            <p-tablist>
              @for (subTab of moduleTab.subcriteriaTabs; track subTab.id; let j = $index) {
                <p-tab
                  [value]="j"
                  [appTabStatus]="scTabCompletionStatus()[j]"
                  [appTabStatusUnsaved]="scTabsUnsaved()[j]"
                >
                  {{ subTab.translations | translateDirectus }}
                </p-tab>
              }
            </p-tablist>

            <p-tabpanels class="mt-4">
              @for (subTab of moduleTab.subcriteriaTabs; track subTab.id; let subIndex = $index) {
                <p-tabpanel [value]="subIndex">
                  @if (activeModuleScTabIndex() === subIndex) {
                    <app-questionnaire-tab-content
                      [twoStage]="twoStageAnswers"
                      [attributes]="subTab.attributes"
                      [badgeListItems]="badgeListItems()"
                      [canSave]="canSave()"
                      [isSaving]="isSaving()"
                      [disabled]="disabled()"
                      [showImportanceScore]="showImportanceScore()"
                      (attributeValueChange)="attributeValueChange.emit($event)"
                      (commentChange)="attributeValueChange.emit($event)"
                      (saveClick)="saveClick.emit()"
                    />
                  }
                </p-tabpanel>
              }
            </p-tabpanels>
          </p-tabs>
        }
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
